import { RefundModel, PaymentInfoModel } from '@/app/shared/models';
import { RefundStatus } from '@/app/shared/enums';
import { Model } from '@/app/shared/models/model';

export class RefundGroupModel extends Model {
  public OpenerUserId?: string;
  public OpenerUserName?: string;
  public UpdatedUserId?: string;
  public UpdatedUserName?: string;
  public Status?: RefundStatus;
  public Name?: string;
  public ContractId?: string;
  public ContractNumber?: string;
  public ContractName?: string;
  public Product?: string;
  public Created?: Date;
  public Updated?: Date;
  public Amount?: number;
  public Refunds!: RefundModel[];
  public PaymentsInfo?: PaymentInfoModel[];
  public TenantId?: string;
  public MarkOff!: boolean;
  public Reason!: string;
  public AllRefundsExternal?: boolean;
}
